import { DocumentNote } from '../types'
import { apiService } from './api.service'

class DocumentNotesService {
  async getNotes(documentId: number): Promise<DocumentNote[]> {
    const response = await apiService.get<DocumentNote[]>(`documents/${documentId}/notes/`)
    return response.data
  }

  async addNote(documentId: number, note: string): Promise<DocumentNote[]> {
    const response = await apiService.post<DocumentNote[]>(`documents/${documentId}/notes/`, {
      note,
    })
    return response.data
  }

  async updateNote(documentId: number, noteId: number, note: string): Promise<DocumentNote[]> {
    const response = await apiService.patch<DocumentNote[]>(`documents/${documentId}/notes/`, {
      id: noteId,
      note,
    })
    return response.data
  }

  async deleteNote(documentId: number, noteId: number): Promise<DocumentNote[]> {
    const response = await apiService.delete<DocumentNote[]>(`documents/${documentId}/notes/`, {
      params: { id: noteId },
    })
    return response.data
  }
}

export const documentNotesService = new DocumentNotesService()
